import { render, staticRenderFns } from "./CompanyReportTabGroupedShiftMeals.vue?vue&type=template&id=639c3fee"
import script from "./CompanyReportTabGroupedShiftMeals.vue?vue&type=script&lang=js"
export * from "./CompanyReportTabGroupedShiftMeals.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports